//https://stackoverflow.com/questions/54560790/detect-click-outside-react-component-using-hooks
import { useState, useEffect, useRef } from 'react';
export default function useComponentVisible(initialIsVisible) {
    var _a = useState(initialIsVisible), isComponentVisible = _a[0], setIsComponentVisible = _a[1];
    var ref = useRef(null);
    var handleHideDropdown = function (event) {
        if (event.key === 'Escape') {
            setIsComponentVisible(false);
        }
    };
    var handleClickOutside = function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
        }
    };
    useEffect(function () {
        document.addEventListener('keydown', handleHideDropdown, true);
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('keydown', handleHideDropdown, true);
            document.removeEventListener('click', handleClickOutside, true);
        };
    });
    return { ref: ref, isComponentVisible: isComponentVisible, setIsComponentVisible: setIsComponentVisible };
}
